import CryptoJS from 'crypto-js'

function validateCardData(cardData) {
  const errors = []

  // Validar número do cartão
  if (!cardData.number || typeof cardData.number !== 'string') {
    errors.push({ code: 'INVALID_NUMBER', message: 'Número do cartão inválido' })
  } else {
    const cleanNumber = cardData.number.replace(/\s/g, '')
    if (!/^\d{13,19}$/.test(cleanNumber)) {
      errors.push({ code: 'INVALID_NUMBER', message: 'Número do cartão inválido' })
    }
  }

  // Validar código de segurança
  if (!cardData.securityCode || typeof cardData.securityCode !== 'string') {
    errors.push({ code: 'INVALID_SECURITY_CODE', message: 'Código de segurança inválido' })
  } else if (!/^\d{3,4}$/.test(cardData.securityCode)) {
    errors.push({ code: 'INVALID_SECURITY_CODE', message: 'Código de segurança inválido' })
  }

  // Validar mês de expiração
  if (!cardData.expMonth || typeof cardData.expMonth !== 'string') {
    errors.push({ code: 'INVALID_EXPIRATION_MONTH', message: 'Mês de expiração inválido' })
  } else {
    const month = parseInt(cardData.expMonth, 10)
    if (isNaN(month) || month < 1 || month > 12) {
      errors.push({ code: 'INVALID_EXPIRATION_MONTH', message: 'Mês de expiração inválido' })
    }
  }

  // Validar ano de expiração
  if (!cardData.expYear || typeof cardData.expYear !== 'string') {
    errors.push({ code: 'INVALID_EXPIRATION_YEAR', message: 'Ano de expiração inválido' })
  } else {
    const year = parseInt('20' + cardData.expYear, 10)
    const currentYear = new Date().getFullYear()
    if (isNaN(year) || year < currentYear || year > currentYear + 20) {
      errors.push({ code: 'INVALID_EXPIRATION_YEAR', message: 'Ano de expiração inválido' })
    }
  }

  // Validar nome do portador
  if (!cardData.holder || typeof cardData.holder !== 'string') {
    errors.push({ code: 'INVALID_HOLDER', message: 'Nome do portador inválido' })
  } else if (cardData.holder.trim().length < 2) {
    errors.push({ code: 'INVALID_HOLDER', message: 'Nome do portador inválido' })
  }

  return {
    isValid: errors.length === 0,
    errors: errors,
  }
}

function encryptCard(cardData, publicKey) {
  try {
    // Validar dados de entrada
    const validation = validateCardData(cardData)
    if (!validation.isValid) {
      return {
        hasErrors: true,
        errors: validation.errors,
        encryptedCard: null,
      }
    }

    // Criar objeto com dados do cartão
    const cardInfo = {
      holder: cardData.holder,
      number: cardData.number,
      expMonth: cardData.expMonth,
      expYear: cardData.expYear,
      securityCode: cardData.securityCode,
      timestamp: new Date().toISOString(),
    }

    // Converter para JSON
    const cardJson = JSON.stringify(cardInfo)

    // Gerar salt aleatório (16 bytes)
    const salt = CryptoJS.lib.WordArray.random(16)

    // Gerar IV aleatório (16 bytes para AES)
    const iv = CryptoJS.lib.WordArray.random(16)

    // Derivar chave usando PBKDF2 com a chave pública como senha
    const key = CryptoJS.PBKDF2(publicKey, salt, {
      keySize: 256 / 32, // 256 bits = 32 bytes = 8 words de 32 bits
      iterations: 10000,
      hasher: CryptoJS.algo.SHA256,
    })

    // Criptografar usando AES-256-CBC
    const encrypted = CryptoJS.AES.encrypt(cardJson, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })

    // Combinar salt + iv + dados criptografados
    const combined = salt.concat(iv).concat(encrypted.ciphertext)

    // Converter para Base64
    const encryptedCard = CryptoJS.enc.Base64.stringify(combined)

    return {
      hasErrors: false,
      errors: [],
      encryptedCard: encryptedCard,
    }
  } catch (error) {
    console.error('Erro na criptografia:', error)
    return {
      hasErrors: true,
      errors: [{ code: 'ENCRYPTION_ERROR', message: 'Erro interno na criptografia' }],
      encryptedCard: null,
    }
  }
}

function detectCodBandeira(brand) {
  const map = { visa: 1, mastercard: 2, elo: 3, hipercard: 4, amex: 5 }
  return map[brand] || 0
}

function cvvLooksOk(brand, cvv) {
  // regra simples: Amex 4 dígitos, demais 3. Ajuste se precisar.
  if (brand === 'amex') return /^\d{4}$/.test(cvv)
  return /^\d{3}$/.test(cvv)
}

function normalizeCreditCard(creditCard) {
  const number = (creditCard.numeroDoCartao || '').replace(/\s+/g, '')
  const holder = (creditCard.nomeImpressoNoCartao || '').trim()
  const expMonth = String(creditCard.mesVencimentoDoCartao || '').padStart(2, '0')
  const expYear = String(creditCard.anoVencimentoDoCartao || '').trim()
  const securityCode = String(creditCard.cvvDoCartao || '').trim()
  return { number, holder, expMonth, expYear, securityCode }
}

export { encryptCard, detectCodBandeira, cvvLooksOk, normalizeCreditCard }
